export default __webpack_public_path__ + "static/media/FS-HOME-SERVICIOS-SEGUIMIENTO-IMAGEN.ea2d910d.png";